
















































import moment from 'moment';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountAdjustBalanceRequestModel from '@/models/bankaccounts/BankAccountAdjustBalanceRequestModel';
import BankAccountFundResponseModel from '@/models/bankaccounts/BankAccountFundResponseModel';

@Component({
        name: 'BankAccountAdjustBalance',
    },
)
export default class BankAccountAdjustBalance extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public adjustIn: number = 0;
    public authorized: boolean = false;

    public get funds(): BankAccountFundResponseModel[] {
        return this.$store.state.selectedBankAccount.funds.filter((x: BankAccountFundResponseModel) => x.isDepositFund === false);
    }

    public adjustFundRules(value: number): any {
        if ( value === 0) {
            return 'A fund is required.';
        }

        return true;
    }

    public created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.ADJUSTMENT )
        {
            this.authorized = true;
        }
    }

    public async saveClick() {
        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new BankAccountAdjustBalanceRequestModel();
                request.adjustmentFundId = this.adjustIn;

                const api = new BankAccountsApi();
                await api.adjustBalanceAsync(this.bankAccountId, this.$store.state.member.jwt, request);

                await this.$router.push({name: 'bankaccountdashboard', params: { bankAccountId: this.bankAccountId.toString(10)}});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.adjustForm;

        return form.validate();
    }

}

